import './CustomerFeedbackPopup.css';

export type tReleaseRecord = {
  sprint: number;
  version: string;
  storiesInRelease: number;
  totalStories: number;
};

interface ReleaseReportPopupProps {
  releaseHistory: tReleaseRecord[];
  closeReleaseReportCallback: () => void;
}

export default function ReleaseReportPopup(props: ReleaseReportPopupProps) {
  return (
    <div className="popup-overlay">
      <div className={`customer-feedback-popup-modal`}>
        <h3>🚀 Release Report</h3>
        <table className="feedback-table">
          <thead>
            <tr>
              <th>Sprint Week</th>
              <th>Version Released</th>
              <th>Stories in Release</th>
              <th>Total Stories Released</th>
            </tr>
          </thead>
          <tbody>
            {props.releaseHistory.map((record, index) => {
              return (
                <tr key={index}>
                  <td>{record.sprint}</td>
                  <td>{record.version}</td>
                  <td style={{ textAlign: 'center' }}>{record.storiesInRelease}</td>
                  <td style={{ textAlign: 'center' }}>{record.totalStories}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <button className="close-button" onClick={props.closeReleaseReportCallback}>Close</button>
      </div>
    </div>
  );
}
